import { createSlice } from '@reduxjs/toolkit';

const documentsSlice = createSlice({
  name: 'documents',
  initialState: {
    checkedItems: [], // Lista zaznaczonych dokumentów [{category, id}]
    activeDocumentsTab: 'Wygenerowane dokumenty', // Domyślna aktywna zakładka
    currentPage: 0, // Domyślna strona (0-indexed)
    maxPages: 1, // Domyślna maksymalna liczba stron
    sortBy: 'createdAt',
    sortDirection: 'DESC', // Domyślny kierunek sortowania
    search: null, // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania
    category: null, // Filtr kategorii
    status: null, // Filtr statusu
    userId: null, // Filtr użytkownika
    createdFrom: null, // Filtr daty od
    createdTo: null, // Filtr daty do
    totalCount: 0, // Całkowita liczba dokumentów
  },
  reducers: {
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload;
    },
    toggleCheckedItem: (state, action) => {
      const item = action.payload; // {category, id}
      const exists = state.checkedItems.some(
        (checked) => checked.category === item.category && checked.id === item.id
      );
      if (exists) {
        state.checkedItems = state.checkedItems.filter(
          (checked) => !(checked.category === item.category && checked.id === item.id)
        );
      } else {
        state.checkedItems.push(item);
      }
    },
    setActiveDocumentsTab(state, action) {
      state.checkedItems = [];
      state.activeDocumentsTab = action.payload;
      state.currentPage = 0;
    },
    setPage(state, action) {
      state.checkedItems = [];
      state.currentPage = action.payload;
    },
    setMaxPages(state, action) {
      state.maxPages = action.payload;
    },
    setSorting(state, action) {
      state.checkedItems = [];
      const { sortBy, sortDirection } = action.payload;
      state.sortBy = sortBy;
      state.sortDirection = sortDirection;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.currentPage = 0;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setCategory(state, action) {
      state.category = action.payload;
      state.currentPage = 0;
    },
    setStatus(state, action) {
      state.status = action.payload;
      state.currentPage = 0;
    },
    setUserId(state, action) {
      state.userId = action.payload;
      state.currentPage = 0;
    },
    setCreatedFrom(state, action) {
      state.createdFrom = action.payload;
      state.currentPage = 0;
    },
    setCreatedTo(state, action) {
      state.createdTo = action.payload;
      state.currentPage = 0;
    },
    setTotalCount(state, action) {
      state.totalCount = action.payload;
    },
    clearFilters(state) {
      state.search = null;
      state.searchValue = '';
      state.category = null;
      state.status = null;
      state.userId = null;
      state.createdFrom = null;
      state.createdTo = null;
      state.currentPage = 0;
    },
  },
});

export const {
  setCheckedItems,
  toggleCheckedItem,
  setActiveDocumentsTab,
  setPage,
  setMaxPages,
  setSorting,
  setSearch,
  setSearchValue,
  setCategory,
  setStatus,
  setUserId,
  setCreatedFrom,
  setCreatedTo,
  setTotalCount,
  clearFilters,
} = documentsSlice.actions;

export default documentsSlice.reducer;








